import { isEmpty } from "lodash";
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { apiGet, apiGet2 } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import InplayTabs from "./InplayTabs";
import io from "socket.io-client";
import LayoutComponent from "../../components/shared/Layout";
import LayoutNew from "../../components/shared/LayoutNew";
import DesktopShell from "../../components/shared/DesktopShell";
import { getData, setData } from "../../Utils/indexedDB";
import CasinoGamesSection from "../../components/home/CasinoGamesSection";

function Inplay() {
  const navigate = useNavigate();
  const TYPES = {
    IN_PLAY: "in_play",
    TODAY: "today",
    TOMORROW: "tomorrow",
  };
  const [type, setType] = useState(TYPES.IN_PLAY);
  const typeRef = useRef(type);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  useEffect(() => {
    typeRef.current = type; // always keep latest
  }, [type]);
  const sportsDataRef = useRef([]);
  let {
    user,
    setSearchToogle,
    setLoader,
    launchCasino,
    parly,
    setInplaySocket,
    inplaySocket,
  } = useContext(AuthProvider);
  let { handelAddMultiMarket } = useContext(BetSlipContext);

  // Pin system — same as Sports.jsx
  const PINNED_LS_KEY = "pinnedEventIds";
  const readPinnedFromLs = () => {
    try {
      const raw = localStorage.getItem(PINNED_LS_KEY);
      if (!raw) return new Set();
      const arr = JSON.parse(raw);
      return new Set(Array.isArray(arr) ? arr.map(String) : []);
    } catch (e) { return new Set(); }
  };
  const writePinnedToLs = (set) => {
    try { localStorage.setItem(PINNED_LS_KEY, JSON.stringify(Array.from(set))); } catch (e) {}
  };
  const pinnedEventIdsRef = useRef(readPinnedFromLs());

  const handelAddMultiMarketLocal = async (eventId) => {
    const idStr = String(eventId);
    const wasPinned = pinnedEventIdsRef.current.has(idStr);
    if (wasPinned) {
      pinnedEventIdsRef.current.delete(idStr);
    } else {
      pinnedEventIdsRef.current.add(idStr);
    }
    writePinnedToLs(pinnedEventIdsRef.current);
    setSportsData((current) => {
      const updated = (current || []).map((item) =>
        String(item.eventId) === idStr
          ? { ...item, multi_market: wasPinned ? 0 : 1 }
          : item,
      );
      return updated.sort((a, b) => {
        const aP = a.multi_market === 1;
        const bP = b.multi_market === 1;
        if (aP !== bP) return aP ? -1 : 1;
        return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
      });
    });
    return handelAddMultiMarket(eventId);
  };

  // Hydrate pins on mount
  useEffect(() => {
    if (isEmpty(user)) return;
    let cancelled = false;
    (async () => {
      try {
        const { status, data } = await apiGet(apiPath.multiMarket);
        if (cancelled) return;
        if (status === 200 && data?.success && Array.isArray(data.results)) {
          const set = new Set(
            data.results.map((r) => String(r?.eventId ?? "")).filter(Boolean),
          );
          pinnedEventIdsRef.current = set;
          writePinnedToLs(set);
          setSportsData((current) =>
            (current || []).map((item) => ({
              ...item,
              multi_market: set.has(String(item.eventId)) ? 1 : 0,
            })),
          );
        }
      } catch (e) {}
    })();
    return () => { cancelled = true; };
  }, []);
  const [loading, setLoading] = useState(false);
  const [sportsData, setSportsData] = useState([]);
  const [desktopMarkets, setDesktopMarkets] = useState({});
  const [inPlayScore, setInPlayScore] = useState([]);
  const [socket, setSocket] = useState({});
  const [checkRefresh, setCheckRefresh] = useState(true);
  
  const inplayScoreSocket = async () => {
    setCheckRefresh(false);
    if (!isEmpty(socket)) {
      socket.disconnect();
    }
    if (!isEmpty(inplaySocket)) {
      inplaySocket.disconnect();
    }
    let randomId = user?.user?._id ? user?.user?._id : 112233;
    const newSocket = io(
      `${import.meta.env.VITE_SOCKET}?token=${randomId}&userType=front`,
      {
        transports: ["websocket"],
      }
    );
    setLoading(false);
    setInplaySocket(newSocket);
    setSocket(newSocket);
    const InPlayScore = (message) => {
      setInPlayScore(message);
    };
    newSocket.on("scoreAll", InPlayScore);
    newSocket.on("disconnect", function () {
      setCheckRefresh(true);
    });
    return () => newSocket.disconnect();
  };

  const transformUserInplaySportData = (newData) => {
    if (!newData) {
      return null;
    }

    // Filter out matches with negative id or eventId
    const matches = newData

    const getGameType = (eventType) => {
      switch (eventType) {
        case 1: return "soccer";
        case 2: return "tennis";
        case 4: return "cricket";
        case 7: return "horseracing";
        case 4339: return "greyhound";
        case 7522: return "basketball";
        default: return "cricket";
      }
    };

    const transformMatches = (matchesArray) => {
      return matchesArray.map(match => {
        const runners = match.market?.selections
          ? match.market.selections.map(selection => ({
              SelectionId: selection.selectionId,
              RunnerName: selection.runnerName
            }))
          : [];

        return {
          _id: match.id.toString(),
          eventId: match.eventId.toString(),
          centralizedId: match.eventId.toString(),
          eventDateTime: new Date(match.openDateTime).toISOString(),
          eventName: match.name,
          eventType: match.eventType.toString(),
          gameType: getGameType(match.eventType),
          marketCount: match.markets ? match.markets.length : 0,
          marketId: match.market ? match.market.marketId : "",
          seriesId: match.competitionId.toString(),
          seriesName: match.competitionName,
          status: match.isInPlay === 1 ? "in_play" : "upcoming",
          timeZone: match.timezone || "GMT",
          runners,
          premiumFancy:
            (match.hasSportsBookMarkets ||
              match.hasOwSportsBookMarkets ||
              match.hasGeniusSportsMarkets)
              ? "on"
              : "off",
          bookMaker:
            (match.hasBookMakerMarkets ||
              match.hasInPlayBookMakerMarkets)
              ? "on"
              : "off",
          fancy:
            (match.hasFancyBetMarkets ||
              match.hasInPlayFancyBetMarkets)
              ? "on"
              : "off",
        };
      });
    };

    return {
      success: newData.status,
      message: newData.message,
      results: transformMatches(matches) // single bucket
    };
  };

  const fetchAllSport = async (isLoader = true) => {
    const currentType = typeRef.current;

    // ✅ 1. Load from IndexedDB FIRST — show cached data instantly
    try {
      const storedData = await getData("sportsData");
      if (storedData && storedData?.data?.matches?.length > 0) {
        setLoader(false);
        setLoading(false);
        appendData(currentType, storedData);
      }
    } catch (e) {
      console.error("IndexedDB read error:", e);
    }

    // ✅ 2. Always fetch fresh data from API
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.matchList + `?game_type=all`
      );

      if (status === 200 && response_users.status) {
        // ✅ 3. Save in IndexedDB
        await setData("sportsData", response_users);

        // ✅ 4. Update UI with fresh data
        appendData(currentType, response_users);
      }
    } catch (err) {
      console.error("Inplay API error:", err);
    }

    setLoading(false);
    setLoader(false);
  };
  const appendData = async (type, storedData) => {
    
    const matches = storedData?.data?.matches || [];

    // Filter by time bucket using the actual API fields:
    // - in_play: isInPlay === 1
    // - today: not in-play AND openDateTime is today
    // - tomorrow: openDateTime is tomorrow
    // - all (no filter): show everything
    const now = new Date();
    const todayStr = now.toDateString();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = tomorrow.toDateString();

    let filteredMatches;
    if (!type || type === "all") {
      filteredMatches = matches;
    } else if (type === "in_play") {
      filteredMatches = matches.filter((m) => m.isInPlay === 1);
    } else if (type === "today") {
      filteredMatches = matches.filter((m) => {
        if (m.isInPlay === 1) return false;
        const matchDate = new Date(m.openDateTime);
        return matchDate.toDateString() === todayStr;
      });
    } else if (type === "tomorrow") {
      filteredMatches = matches.filter((m) => {
        const matchDate = new Date(m.openDateTime);
        return matchDate.toDateString() === tomorrowStr;
      });
    } else {
      filteredMatches = matches;
    }
    // Transform new data format to old format
    const transformedData = transformUserInplaySportData(filteredMatches);
    let newData = transformedData.results || [];

    // Sort matches by eventDateTime, but push Virtual competitions to the bottom
    newData = newData.sort((a, b) => {
      const aVirtual = a.seriesName?.toLowerCase().includes("virtual");
      const bVirtual = b.seriesName?.toLowerCase().includes("virtual");

      if (aVirtual !== bVirtual) return aVirtual ? 1 : -1;
      
      return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
    });

    setSportsData((prevData = []) => {
      const prevMap = new Map(
        prevData.map((item) => [String(item.eventId), item])
      );

      // ✅ Convert score to map (O(n))
      const scoreMap = new Map(
        (inPlayScore || []).map((s) => [String(s.eventId), s])
      );

      const pinnedSet = pinnedEventIdsRef.current || new Set();

      return newData.map((item) => {
        const existing = prevMap.get(String(item.eventId));
        const score = scoreMap.get(String(item.eventId));
        const multi_market = pinnedSet.has(String(item.eventId)) ? 1 : 0;

        return {
          ...item,
          multi_market,

          // ✅ Preserve odds
          ...(existing && {
            back_odds: existing.back_odds,
            lay_odds: existing.lay_odds,
            totalMatched: existing.totalMatched,
            matchOddsData: existing.matchOddsData,
          }),

          // ✅ Add score
          score: score?.score && score.score !== 0 ? score.score : "",
          timeElapsed: score?.timeElapsed || "",
        };
      });
    });
    setLoader(false);
  }
  const transformMatchDataToOldFormat = (newData) => {
    if (!newData || !newData.data || !Array.isArray(newData.data)) {
      return null;
    }

    // Transform all market data entries
    const transformedMarkets = newData.data.map(marketData => {
      const msValue = marketData.status === "OPEN" ? 1 : marketData.status === "SUSPENDED" ? 3 : 1;

      const runners = marketData.selections.map(selection => ({
        selectionId: selection.selectionId,
        handicap: selection.handicap,
        status: selection.status,
        lastPriceTraded: selection.lastPriceTraded,
        totalMatched: selection.totalMatched,
        adjustmentFactor: 0,
        ex: {
          availableToBack: selection.availableToBack.length > 0
            ? selection.availableToBack
            : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }],
          availableToLay: selection.availableToLay.length > 0
            ? selection.availableToLay
            : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }]
        }
      }));

      let rt = [];

      marketData.selections.forEach(selection => {
        if (selection.availableToBack && selection.availableToBack.length > 0) {
          selection.availableToBack.forEach(back => {
            rt.push({
              ri: selection.selectionId,
              rt: back.price,
              bv: back.size,
              ib: true
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: true
            });
          }
        }

        if (selection.availableToLay && selection.availableToLay.length > 0) {
          selection.availableToLay.forEach(lay => {
            rt.push({
              ri: selection.selectionId,
              rt: lay.price,
              bv: lay.size,
              ib: false
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: false
            });
          }
        }
      });

      return {
        mi: marketData.marketId,
        ms: msValue,
        totalMatched: marketData.totalMatched,
        rt: rt,
        runners: runners,
        lastMatchTime: marketData.lastMatchTime,
        ts: new Date().toISOString().replace('T', ' ').substring(0, 19),
        eventId: marketData.eventId,
        eventType: marketData.eventType
      };
    });

    return {
      success: newData.status,
      message: newData.message,
      results: transformedMarkets
    };
  };

  const transformMarketForEvent = (marketData) => {
    if (!marketData) return null;

    const msValue = marketData.status === "OPEN" ? 1 : marketData.status === "SUSPENDED" ? 3 : 1;

    const runners = marketData.selections.map(selection => ({
      selectionId: selection.selectionId,
      handicap: selection.handicap,
      status: selection.status,
      lastPriceTraded: selection.lastPriceTraded,
      totalMatched: selection.totalMatched,
      adjustmentFactor: 0,
      ex: {
        availableToBack: selection.availableToBack.length > 0
          ? selection.availableToBack
          : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }],
        availableToLay: selection.availableToLay.length > 0
          ? selection.availableToLay
          : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }]
      }
    }));

    let rt = [];

    marketData.selections.forEach(selection => {
      if (selection.availableToBack && selection.availableToBack.length > 0) {
        selection.availableToBack.forEach(back => {
          rt.push({
            ri: selection.selectionId,
            rt: back.price,
            bv: back.size,
            ib: true
          });
        });
      } else {
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: true
          });
        }
      }

      if (selection.availableToLay && selection.availableToLay.length > 0) {
        selection.availableToLay.forEach(lay => {
          rt.push({
            ri: selection.selectionId,
            rt: lay.price,
            bv: lay.size,
            ib: false
          });
        });
      } else {
        for (let i = 0; i < 3; i++) {
          rt.push({
            ri: selection.selectionId,
            rt: 0,
            bv: 0,
            ib: false
          });
        }
      }
    });

    return {
      mi: marketData.marketId,
      ms: msValue,
      totalMatched: marketData.totalMatched,
      rt: rt,
      runners: runners,
      lastMatchTime: marketData.lastMatchTime,
      ts: new Date().toISOString().replace('T', ' ').substring(0, 19),
      eventId: marketData.eventId,
      eventType: marketData.eventType
    };
  };

  const getMatchOdds = async (eventIds) => {
    if (!eventIds || eventIds.length === 0) return;

    try {
      const { status, data: response } = await apiGet2(
        apiPath.getMatchOdds + `?match_ids=${eventIds.join(",")}`
      );

      if (status === 200 && response.status && response.data) {
        // Keep the raw market objects (keyed eventId:marketId) so the desktop
        // match grid can render the 1/X/2 back-lay odds boxes like the Home page.
        const rawMarkets = {};
        response.data.forEach(market => {
          rawMarkets[`${market.eventId}:${market.marketId}`] = market;
        });
        setDesktopMarkets(rawMarkets);

        // Create a map of eventType from current sportsData
        const eventTypesMap = {};
        sportsDataRef.current?.forEach(item => {
          eventTypesMap[item.eventId] = item.eventType;
        });

        // Group markets by eventId
        const marketsByEvent = {};
        response.data.forEach(market => {
          if (!marketsByEvent[market.eventId]) {
            marketsByEvent[market.eventId] = [];
          }
          marketsByEvent[market.eventId].push(market);
        });

        // Transform each event's market data
        const transformedByEvent = {};
        Object.keys(marketsByEvent).forEach(eventId => {
          const markets = marketsByEvent[eventId];
          const eventType = eventTypesMap[eventId];
          
          // For soccer (eventType 1), if there are multiple markets, use only the first one
          let marketToUse;
          if (eventType === 1 && markets.length > 1) {
            marketToUse = markets[0];
          } else {
            marketToUse = markets[0];
          }
          
          transformedByEvent[eventId] = transformMarketForEvent(marketToUse);
        });

        const transformedMarkets = Object.values(transformedByEvent).filter(m => m !== null);

        if (transformedMarkets && transformedMarkets.length > 0) {
          setSportsData((current) =>
            current?.map((obj) => {
              // Find the matching market data for this event
              const socket_data = transformedMarkets.find(
                (market) => String(market.eventId) === String(obj.eventId)
              );

              if (socket_data) {
                const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
                const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
                return {
                  ...obj,
                  back_odds,
                  lay_odds,
                  totalMatched: socket_data?.totalMatched,
                  matchOddsData: socket_data
                };
              }
              return obj;
            })
          );
        }
      }
    } catch (error) {
      console.error("Error fetching match odds:", error);
    }
  };

  useEffect(() => {
    sportsDataRef.current = sportsData;
  }, [sportsData]);

  useEffect(() => {
    if (!loading) return;

    fetchAllSport();
    inplayScoreSocket(); // ✅ only once here

  }, [loading]);

  useEffect(() => {
    if (!inPlayScore?.length) return;

    const scoreMap = new Map(
      inPlayScore.map((item) => [item.eventId, item])
    );

    setSportsData((current) =>
      current.map((res) => {
        const temp = scoreMap.get(res.eventId);

        return {
          ...res,
          score: temp?.score && temp.score !== 0 ? temp.score : "",
          timeElapsed: temp?.timeElapsed || "",
        };
      })
    );
  }, [inPlayScore]);

  useEffect(() => {
    if (checkRefresh) {
      inplayScoreSocket();
    }
  }, [checkRefresh]);

  useEffect(() => {
    // When user switches tab (In-Play / Today / Tomorrow),
    // immediately show cached data then refresh from API
    fetchAllSport(false);
  }, [type]);

  useEffect(() => {
    let isFetching = false;

    const callApi = async () => {
      if (isFetching) return; // prevent overlapping calls only

      isFetching = true;
      await fetchAllSport(false);
      isFetching = false;
    };

    callApi(); // always fetch on mount

    // Poll every 60s, skip if tab is hidden
    const interval = setInterval(() => {
      if (!document.hidden) callApi();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  // Polling for match odds - runs every 3 seconds (near real-time)
  const hasDataRef = useRef(false);
  const pollingRef = useRef(null);

  useEffect(() => {
    const poll = () => {
      if (document.hidden) return; // skip when tab not visible
      const currentData = sportsDataRef.current;

      if (!currentData || currentData.length === 0) return;

      const eventIds = currentData
        .map(item => item.eventId)
        .filter(id => id);

      if (eventIds && eventIds.length > 0) {
        getMatchOdds(eventIds);
      }
    };

    // run immediately when sportsData first becomes available
    if (sportsData && sportsData.length > 0 && !hasDataRef.current) {
      hasDataRef.current = true;
      poll();
    }

    // start interval only once
    if (!pollingRef.current) {
      pollingRef.current = setInterval(poll, 3000);
    }

    return () => {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    };
  }, [sportsData]);

  useEffect(() => {
    const handleVisibility = () => {
      if (!document.hidden && !checkRefresh) {
        if (!isEmpty(socket)) {
          socket.disconnect();
        }
        setCheckRefresh(true);
      } else {
        setCheckRefresh(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, [socket, checkRefresh]);
  const withDesktopMarket = (arr) =>
    isDesktop ? arr.map(item => ({ ...item, desktopMarket: desktopMarkets[`${item.eventId}:${item.marketId}`] })) : arr;
  const pageContent = (
      <div className="mian-wrap inplay-page">
        <div className="tab-wrap inplay-date-tabs">
          <ul>
            <li
              id="inplay"
              className={type == "in_play" ? "select" : ""}
              onClick={() => {
                setType(TYPES.IN_PLAY);;
              }}
            >
              <a href="javascript:void(0)" neua="In-Play">
                In-Play
              </a>
            </li>
            <li
              id="today"
              className={type == "today" ? "select" : ""}
              onClick={() => {
                setType(TYPES.TODAY);
              }}
            >
              <a href="javascript:void(0)">Today</a>
            </li>
            <li
              id="tomorrow"
              className={type == "tomorrow" ? "select" : ""}
              onClick={() => {
                setType(TYPES.TOMORROW);
              }}
            >
              <a href="javascript:void(0)">Tomorrow</a>
            </li>
          </ul>
        </div>
        {/* {console.log(sportsData)} */}
        {sportsData && sportsData.length > 0 && (
          <>
            {sportsData?.filter((res) => res.gameType == "soccer")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "soccer")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Soccer"}
                sportsId={1}
              />
            )}
            {sportsData?.filter((res) => res.gameType == "tennis")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "tennis")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Tennis"}
                sportsId={2}
              />
            )}
            {sportsData?.filter((res) => res.gameType == "cricket")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "cricket")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Cricket"}
                sportsId={4}
                cricketBadges
              />
            )}
            {sportsData?.filter((res) => res.gameType == "horseracing")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "horseracing")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Horse Racing"}
                sportsId={7}
              />
            )}
            {sportsData?.filter((res) => res.gameType == "greyhound")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "greyhound")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Greyhound Racing"}
                sportsId={4339}
              />
            )}
            {sportsData?.filter((res) => res.gameType == "basketball")?.length >
              0 && (
              <InplayTabs
                showPin={false}
                type={type}
                parlyTab={parly}
                desktop={isDesktop}
                desktopHeadings
                data={withDesktopMarket(sportsData?.filter((res) => res.gameType == "basketball")?.sort((a, b) => {
                  const aP = a.multi_market === 1; const bP = b.multi_market === 1;
                  if (aP !== bP) return aP ? -1 : 1;
                  return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
                }) || [])}
                handelAddMultiMarket={handelAddMultiMarketLocal}
                setLoading={setLoading}
                sportsType={"Basketball"}
                sportsId={7522}
              />
            )}
          </>
        )}

        {/* Casino games section — same layout as the Home page */}
        <CasinoGamesSection />
      </div>
  );

  return (
    <>
      {isDesktop ? (
        <LayoutNew desktopHome>
          <DesktopShell activeNav="In-Play">{pageContent}</DesktopShell>
        </LayoutNew>
      ) : (
        <LayoutComponent visibilityType={true}>{pageContent}</LayoutComponent>
      )}
    </>
  );
}

export default Inplay;
